import React from 'react'

function Filter2Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M11.9081 24.7806L12.2243 25.7293H12.2243L11.9081 24.7806ZM18.4081 22.614L18.0919 21.6653L18.0919 21.6653L18.4081 22.614ZM24.7071 9.04289L25.4142 9.75L24.7071 9.04289ZM6 6H24V4H6V6ZM6 8.33579V6H4V8.33579H6ZM11.6642 14L6 8.33579L4.58579 9.75L10.25 15.4142L11.6642 14ZM10.25 15.4142V24.3063H12.25V15.4142H10.25ZM10.25 24.3063C10.25 25.3301 11.253 26.0531 12.2243 25.7293L11.5919 23.832C11.9156 23.724 12.25 23.965 12.25 24.3063H10.25ZM12.2243 25.7293L18.7243 23.5627L18.0919 21.6653L11.5919 23.832L12.2243 25.7293ZM18.7243 23.5627C19.3368 23.3585 19.75 22.7853 19.75 22.1396H17.75C17.75 21.9244 17.8877 21.7333 18.0919 21.6653L18.7243 23.5627ZM19.75 22.1396V15.4142H17.75V22.1396H19.75ZM24 8.33579L18.3358 14L19.75 15.4142L25.4142 9.75L24 8.33579ZM24 6V8.33579H26V6H24ZM25.4142 9.75C25.7893 9.37493 26 8.86622 26 8.33579H24L25.4142 9.75ZM19.75 15.4142V15.4142L18.3358 14C17.9607 14.3751 17.75 14.8838 17.75 15.4142H19.75ZM10.25 15.4142H12.25C12.25 14.8838 12.0393 14.3751 11.6642 14L10.25 15.4142ZM4 8.33579C4 8.86622 4.21071 9.37493 4.58579 9.75L6 8.33579L6 8.33579H4ZM24 6H26C26 4.89543 25.1046 4 24 4V6ZM6 4C4.89543 4 4 4.89543 4 6H6V6V4Z"
        fill="#393D63"
      />
    </svg>
  )
}

export default Filter2Icon
